/* Royal Intimacy — Product Page Scripts v3 */
/* Pairs with sections/royal-product.liquid */
/* v3 changes: single-thumb gallery hide, dynamic unit_label in price toggle */

(function() {
  'use strict';

  /* ===== GALLERY ===== */
  function initGallery() {
    var thumbs = document.querySelectorAll('.ri-gallery-thumb');
    var main = document.querySelector('.ri-gallery-main');
    if (!main || !thumbs.length) return;

    /* v3: hide thumbnail row if only 1 image (fallback for browsers without :has) */
    var thumbWrap = document.querySelector('.ri-gallery-thumbs');
    if (thumbWrap && thumbs.length <= 1) {
      thumbWrap.classList.add('single-thumb');
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var img = thumb.querySelector('img');
        var mainImg = main.querySelector('img');
        if (img && mainImg) {
          mainImg.src = img.src.replace(/width=\d+/, 'width=960');
          mainImg.alt = img.alt;
        }
      });
    });
  }

  /* ===== PURCHASE TYPE TOGGLE ===== */
  var purchaseType = 'subscribe';
  var selectedVariantId = null;
  var selectedSellingPlan = null;

  function initPurchaseToggle() {
    var tabs = document.querySelectorAll('.ri-toggle-tab');
    var cadenceWrap = document.querySelector('.ri-cadence');
    var perksWrap = document.querySelector('.ri-sub-perks');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        purchaseType = tab.dataset.type;
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');

        if (purchaseType === 'subscribe') {
          if (cadenceWrap) cadenceWrap.style.display = 'flex';
          if (perksWrap) perksWrap.style.display = 'flex';
        } else {
          if (cadenceWrap) cadenceWrap.style.display = 'none';
          if (perksWrap) perksWrap.style.display = 'none';
          selectedSellingPlan = null;
        }

        updatePrices();
      });
    });
  }

  /* ===== CADENCE SELECTOR ===== */
  function initCadence() {
    var btns = document.querySelectorAll('.ri-cadence-btn');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedSellingPlan = btn.dataset.planId || null;
      });
    });
  }

  /* ===== VARIANT SELECTOR ===== */
  function initVariants() {
    var cards = document.querySelectorAll('.ri-var-card');
    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        cards.forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        selectedVariantId = card.dataset.variantId;
        updateATCPrice(card);
      });
    });

    // Set initial variant
    var initial = document.querySelector('.ri-var-card.selected');
    if (initial) {
      selectedVariantId = initial.dataset.variantId;
    }
  }

  function updateATCPrice(card) {
    var price = purchaseType === 'subscribe'
      ? card.dataset.priceSub
      : card.dataset.priceOnetime;
    var stickyPrice = document.querySelector('.ri-sticky-price');
    if (stickyPrice) {
      stickyPrice.textContent = 'From $' + price;
    }
  }

  /* v3: read unit_label from the first variant card's per-unit text so
     the toggle between subscribe/one-time preserves the correct label
     (e.g. "condom", "wipe", "oz") instead of always showing "/condom" */
  function getUnitLabel() {
    var perEl = document.querySelector('.ri-v-per');
    if (perEl) {
      var text = perEl.textContent || '';
      var slash = text.lastIndexOf('/');
      if (slash !== -1) {
        return text.substring(slash + 1).trim();
      }
    }
    return 'unit';
  }

  function updatePrices() {
    var unitLabel = getUnitLabel();
    var cards = document.querySelectorAll('.ri-var-card');

    cards.forEach(function(card) {
      var priceEl = card.querySelector('.ri-v-price');
      var perEl = card.querySelector('.ri-v-per');
      if (!priceEl) return;

      var price, perUnit;
      var count = parseInt(card.dataset.count) || 1;

      if (purchaseType === 'subscribe') {
        price = parseFloat(card.dataset.priceSub);
      } else {
        price = parseFloat(card.dataset.priceOnetime);
      }

      perUnit = (price / count).toFixed(2);
      priceEl.textContent = price.toFixed(2);
      if (perEl) perEl.textContent = '$' + perUnit + '/' + unitLabel;
    });

    // Update selected card's sticky price
    var selected = document.querySelector('.ri-var-card.selected');
    if (selected) updateATCPrice(selected);
  }

  /* ===== QUANTITY ===== */
  function initQuantity() {
    var minus = document.querySelector('.ri-qty-minus');
    var plus = document.querySelector('.ri-qty-plus');
    var display = document.querySelector('.ri-qty-val');
    var qty = 1;

    if (!minus || !plus || !display) return;

    minus.addEventListener('click', function() {
      if (qty > 1) { qty--; display.textContent = qty; }
    });
    plus.addEventListener('click', function() {
      if (qty < 10) { qty++; display.textContent = qty; }
    });
  }

  /* ===== ADD TO CART ===== */
  function initATC() {
    var btns = document.querySelectorAll('.ri-atc-btn, .ri-sticky-btn');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!selectedVariantId) return;

        var qtyEl = document.querySelector('.ri-qty-val');
        var qty = qtyEl ? parseInt(qtyEl.textContent) : 1;

        var body = {
          items: [{
            id: parseInt(selectedVariantId),
            quantity: qty
          }]
        };

        if (purchaseType === 'subscribe' && selectedSellingPlan) {
          body.items[0].selling_plan = parseInt(selectedSellingPlan);
        }

        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          setTimeout(function() {
            btn.textContent = 'Add to Cart \u2192';
            btn.disabled = false;
          }, 1500);

          // Open cart drawer if available
          if (typeof document.querySelector('.cart-drawer') !== 'undefined') {
            document.body.classList.add('cart-open');
          }
        })
        .catch(function() {
          btn.textContent = 'Error \u2014 try again';
          btn.disabled = false;
        });
      });
    });
  }

  /* ===== CROSS-SELL ATC BUTTONS ===== */
  function initCrossSellATC() {
    var crossBtns = document.querySelectorAll('.ri-cross-atc');
    crossBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }]
          })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
      });
    });
  }

  /* ===== STICKY ATC BAR ===== */
  function initStickyBar() {
    var bar = document.getElementById('ri-sticky-bar');
    var atcRow = document.querySelector('.ri-atc-row');
    if (!bar || !atcRow) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('visible');
        } else {
          bar.classList.add('visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcRow);
  }

  /* ===== DROPDOWNS (ATF) ===== */
  function initDropdowns() {
    var heads = document.querySelectorAll('.ri-dropdown-head');
    heads.forEach(function(head) {
      head.addEventListener('click', function() {
        var parent = head.parentElement;
        parent.classList.toggle('open');
      });
    });
  }

  /* ===== FAQ ACCORDION ===== */
  function initFAQ() {
    var questions = document.querySelectorAll('.ri-faq-q');
    questions.forEach(function(q) {
      q.addEventListener('click', function() {
        var item = q.parentElement;
        var isOpen = item.classList.contains('open');

        // Close all others
        document.querySelectorAll('.ri-faq-item.open').forEach(function(openItem) {
          openItem.classList.remove('open');
        });

        // Toggle clicked
        if (!isOpen) item.classList.add('open');
      });
    });

    /* On mobile, default all FAQ items closed */
    if (window.innerWidth <= 768) {
      document.querySelectorAll('.ri-faq-item.open').forEach(function(item) {
        item.classList.remove('open');
      });
    }
  }

  /* ===== COMPARISON TABLE SCROLL HINT ===== */
  /* v3: this is now a no-op on mobile since the table uses table-layout:fixed
     and no longer scrolls. Kept for desktop/tablet edge cases. */
  function initTableScrollHint() {
    if (window.innerWidth <= 768) return;

    var wrap = document.querySelector('.ri-compare-scroll-wrap');
    var hint = document.querySelector('.ri-compare-scroll-hint');
    var label = document.querySelector('.ri-compare-scroll-label');
    if (!wrap || !hint) return;

    wrap.addEventListener('scroll', function() {
      var scrollLeft = wrap.scrollLeft;
      if (scrollLeft > 20) {
        hint.style.opacity = '0';
        if (label) label.style.opacity = '0';
      } else {
        hint.style.opacity = '1';
        if (label) label.style.opacity = '1';
      }
    });
  }

  /* ===== INIT ===== */
  function init() {
    initGallery();
    initPurchaseToggle();
    initCadence();
    initVariants();
    initQuantity();
    initATC();
    initCrossSellATC();
    initStickyBar();
    initDropdowns();
    initFAQ();
    initTableScrollHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();